import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ContractType } from 'src/app/models/entities/contract-type';
import { ContractTypeService } from 'src/app/services/contract-type.service';

@Component({
  selector: 'app-contract-type',
  templateUrl: './contract-type.component.html',
  styleUrls: ['./contract-type.component.css']
})
export class ContractTypeComponent implements OnInit {

  destroy$ = new Subject<void>();
  contractTypes$: Observable<ContractType[]>;
  deleteModal: boolean;
  contractTypeId: number;
  @ViewChild('dt', { static: false }) dt: any;
  constructor(private contractTypeService: ContractTypeService,private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getList();
  }

  getList(){
    this.contractTypes$ = this.contractTypeService.getList().pipe(map(result => result.data));
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

  showDeleteModal(contractTypeId: number) {
    this.deleteModal = true;
    this.contractTypeId = contractTypeId;
  }

  deleteContractType() {
    this.deleteModal = false;
    this.contractTypeService.delete(this.contractTypeId).pipe(takeUntil(this.destroy$)).subscribe(
      result => {
        this.toastrService.success(result.message, "BAŞARILI!");
        this.getList();
      },
      er => {
        this.toastrService.error(er.error.message, "HATA!");
      }
    )
  }
}
